export class OutletContentFromJsonRequestDto {
    outletId: number;
    outletContentTypeId: number;
    ghostWriterId: number;
    json: string;
}
